import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate } from "../Helpers";
import { TiUser } from "react-icons/ti";
import { FaFemale, FaMale } from "react-icons/fa";
import { STR_FEMALE, STR_MALE, STR_OPEN } from "../Strings";
import { BsChatDots } from "react-icons/bs";
import { MdLocationPin } from "react-icons/md";

export default function View({ data }) {
  const appContext = useContext(AppContext);

  /* Place states here */

  function open() {
    
    if(data.navable) {
			appContext.navTo({
				item: data.navItem,
				subItem: data.navSubItem,
				extraItem: data.navExtraItem,
				moreItem: data.navMoreItem,
			})
    }

  }

  return (
    <div 
			className="bg-surface mb-2"
			style={{
				padding: "10px",
				borderRadius: "20px"
			}}
		>
      <h6
				style={{
					fontSize: "14px"
				}}
			>
				{data.message[appContext.language]}
			</h6>

			<h6
				style={{
					fontSize: "10px"
				}}
				className="font-light mt-3"
			>
				{formatDate(data.timestamp)}
			</h6>

			{
				(data.navable) ?
				<div className="text-end mt-2">
					<button
						className="btn btn-sm btn-secondary btn-rounded"
						onClick={open}
					>
						{STR_OPEN[appContext.language]}
					</button>
				</div>
				:""
			}
    </div>
  )
}
